<template>
  <div class="classIntroductionBox">
    <div v-html="info.profile"></div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "秒懂选课",
    };
  },
  data() {
    return {
      info: "",
      sclasscode: "",
    };
  },
  created() {
    this.sclasscode = this.$route.query.sclasscode
      ? this.$route.query.sclasscode
      : "";
    this.getTool();
  },
  methods: {
    getTool() {
      var obj = {
        sclasscode: this.sclasscode,
      };
      this.$post("/iart-api-scm/api/scm/tool/queryToolByClasscodeid", obj).then(
        (res) => {
          if (res.code == 1) {
            this.info = res.data;
          } else {
            this.util.toast({
              msg: res.message,
            });
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.classIntroductionBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  overflow: auto;
  padding: 16px;
}
</style>